import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { useRouter } from "next/router";
import { useMemo, useState } from "react";
import {
  CategoryProductSwiperBreakPoints,
  HomeProductSwiperBreakPoints,
} from "@/constants/BreakPoints";

import Tabs from "./Tabs";
import ProductCard from "../ProductCard";
import ArrowIcon from "@/components/icons/ArrowIcon";
import useScreenSize from "@/hooks/display/useDisplay";
import LazyLoading from "@/components/LazyLoading";
import { v4 as uuidv4 } from "uuid";
import Sort from "./sort";

// Used in Home Page and Category Page
const ProductSwiper = ({
  data: fromHomeData,
  fromCategory = null,
  handleSwitchTabs = null,
  isTopCategoryTabsLoading,
  filters,
  handleFilterChange,
  selectedFilters,
  t,
  tab,
}) => {
  const [swiper, set_swiper] = useState({});
  const [active, setActive] = useState(0);
  const { isResponsive, screenWidth } = useScreenSize();
  const { locale } = useRouter();
  const { pathname } = useRouter();
  const data = useMemo(() => {
    return fromHomeData
      ? {
          tabs: fromHomeData?.value?.map((item) => ({
            ...item,
            img: `${process?.env?.NEXT_PUBLIC_IMG_BASEURL}/json/${
              item[`img-${locale}`]
            }`,
          })),
        }
      : { tabs: fromCategory };
  }, [fromCategory, fromHomeData, locale]);

  return (
    <section>
      <Tabs
        {...{
          active,
          setActive,
          locale,
          tabsTitles: fromHomeData?.value,
          fromCategory,
          title:
            fromHomeData && `title-${locale}` in fromHomeData
              ? fromHomeData[`title-${locale}`]
              : "",
          handleSwitchTabs,
        }}
      />
      {pathname.includes("/cp/") ? (
        <Sort
          {...{
            filters,
            t: t,
            handleFilterChange,
            selectedFilters,
            tab,
          }}
        />
      ) : null}
      <div className="min-h-[260px] sm:min-h-[395px]">
        {isTopCategoryTabsLoading && pathname.includes("/cp/") ? (
          <LazyLoading parentClassName={"min-h-[260px] sm:min-h-[395px]"} />
        ) : (
          <div className="relative">
            {Array.isArray(data?.tabs) && data?.tabs?.length
              ? data?.tabs?.map((tab, idx) =>
                  active === idx ? (
                    <Swiper
                      onInit={(e) => set_swiper(e)}
                      loop={
                        (tab?.products?.length > 5 && screenWidth > 769) ||
                        screenWidth < 769
                      }
                      key={locale}
                      dir={locale === "ar" ? "rtl" : "ltr"}
                      className="mt-4 px-0.5"
                      spaceBetween={isResponsive ? 20 : 10}
                      modules={[Autoplay]}
                      autoplay={{
                        delay: 3500,
                        disableOnInteraction: false,
                      }}
                      breakpoints={
                        !fromCategory
                          ? HomeProductSwiperBreakPoints
                          : CategoryProductSwiperBreakPoints
                      }
                    >
                      {tab?.products?.length ? (
                        tab?.products?.map((product) => (
                          <SwiperSlide key={uuidv4()}>
                            <ProductCard {...{ product }} fromSwiper />
                          </SwiperSlide>
                        ))
                      ) : (
                        <div className="flex items-center justify-center text-2xl text-gray-300 min-h-40">
                          {locale === "ar"
                            ? "لا توجد منتجات"
                            : " No products found"}
                        </div>
                      )}
                    </Swiper>
                  ) : null
                )
              : null}
            {tab.products?.length > 0 ? (
              <>
                <button
                  onClick={() => swiper?.slidePrev()}
                  className={`${
                    fromCategory
                      ? data?.tabs[active]?.products?.length > 4
                        ? "flex"
                        : "hidden"
                      : ""
                  } cursor-pointer absolute top-1/3 -left-3 z-30 size-9 rounded-full ${
                    !fromCategory
                      ? "max-[640px]:hidden max-[768px]:flex min-[768px]:hidden max-[1023px]:hidden lg:flex"
                      : "flex"
                  } items-center justify-center bg-primary text-white`}
                >
                  <ArrowIcon className="rotate-180 size-4" />
                </button>
                <button
                  onClick={() => swiper?.slideNext()}
                  className={`${
                    fromCategory
                      ? data?.tabs[active]?.products?.length > 4
                        ? "flex"
                        : "hidden"
                      : ""
                  } cursor-pointer absolute top-1/3 -right-3 z-30 size-9 rounded-full ${
                    !fromCategory
                      ? "max-[640px]:hidden max-[768px]:flex min-[768px]:hidden max-[1023px]:hidden lg:flex"
                      : "flex"
                  } items-center justify-center bg-primary text-white`}
                >
                  <ArrowIcon className="size-4" />
                </button>{" "}
              </>
            ) : (
              ""
            )}
          </div>
        )}
      </div>
    </section>
  );
};

export default ProductSwiper;
